import { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_GENERAL_CANCELAR, ESTILO_INPUT_GENERICO } from "../../../utils/const/estilos-const";
import "../../../style/style-cargando.css";
import ArrowBack from "../../../components/arrow-back";
import { useTranslation } from "react-i18next";
import ProcessingDialog from "../../../components/processing-dialog";
import ToastComponent from "../../../components/toast-component";
import BtnRequestComponent from "../../../components/btn-request";
import { mergePermisosPages, usePages } from "./pages-const";
import { sharedCloneObject, sharedDedupeSelectOptions, } from "../../../utils/shared-functions";
import { obtenerTodasLasUnidades } from "../../../api/gestion-dts/gestion";
import Select from "react-select";
import { obtenerListaGrupos, obtenerListaSubGrupos } from "../../../api/gestion-dts/api-rastreo-v4";
import { actualizarPermisoRolUsuarioWeb, crearPermisoRolUsuarioWeb, obtenerPermisoRolUsuarioWeb } from "../../../api/api-permiso-rol-usuario-web";
import CargandoCard from "../../../components/cargando-card";
import { ChevronDown, ChevronRight } from "lucide-react";

const CHECKBOX_CLASS =
  "w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2";

const getPagesInSection = (menu) => {
  if (menu.subMenu === null) return [menu];
  if (Array.isArray(menu.subMenu)) return menu.subMenu;
  return [];
};

const getSectionAcciones = (menu) => {
  const pages = getPagesInSection(menu);
  const map = new Map();
  for (const page of pages) {
    if (Array.isArray(page.acciones)) {
      for (const accion of page.acciones) {
        if (!map.has(accion.value)) {
          map.set(accion.value, accion.label);
        }
      }
    }
  }
  return Array.from(map.entries()).map(([value, label]) => ({ value, label }));
};

export default function PermisosPage() {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const initialLoadDoneRef = useRef(false);
  const [cargandoPage, setCargandoPage] = useState(true);
  const [formData, setFormData] = useState(null);
  // const [listaCategoria, setListaCategoria] = useState([]);
  // const [categoriaSelected, setCategoriaSelected] = useState(null);

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning");

  const [sendRequest, setSendRequest] = useState(false);

  const listaPagesTemplate = usePages();
  const [permisosPages, setPermisosPages] = useState([]);

  const [listaVehiculos, setListaVehiculos] = useState([]);
  const [vehiculoSelected, setVehiculoSelected] = useState(null);

  const [listaGrupos, setListaGrupos] = useState([]);
  const [grupoSelected, setGrupoSelected] = useState(null);

  const [listaSubGrupos, setListaSubGrupos] = useState([]);
  const [subGrupoSelected, setSubGrupoSelected] = useState(null);

  const [idPermisoRolUsuarioWeb, setIdPermisoRolUsuarioWeb] = useState(null);
  const [expandedMenus, setExpandedMenus] = useState(new Set());

  useEffect(() => {
    iniciar();
  }, []);

  useEffect(() => {
    if (!initialLoadDoneRef.current) return;
    setPermisosPages((prev) => {
      if (prev.length === 0) return prev;
      return mergePermisosPages(listaPagesTemplate, prev);
    });
  }, [listaPagesTemplate]);

  useEffect(() => {
    setExpandedMenus((prev) => {
      if (prev.size > 0 || permisosPages.length === 0) return prev;
      return new Set(permisosPages.map((_, index) => index));
    });
  }, [permisosPages]);

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log('data', data);
      if (data !== undefined && data !== null) {
        const params = data.params;
        // console.log('params', params);
        setFormData(params);
      }
      let permisosMerged = sharedCloneObject(listaPagesTemplate);

      const listaUnidades = await obtenerTodasLasUnidades();
      // console.log('listaUnidades');
      // console.log(listaUnidades);
      if (Array.isArray(listaUnidades) && listaUnidades.length > 0) {
        setListaVehiculos(listaUnidades);
      }
      let listaGruposEmpresa = await obtenerListaGrupos();
      // console.log('listaGruposEmpresa');
      // console.log(listaGruposEmpresa);
      if (listaGruposEmpresa.error === false && Array.isArray(listaGruposEmpresa.data) && listaGruposEmpresa.data.length > 0) {
        setListaGrupos(listaGruposEmpresa.data);
      }

      const permiso = await obtenerPermisoRolUsuarioWeb({ idRolUsuarioWeb: data.params.id });
      // console.log('permiso', permiso);
      if (permiso.error === false && permiso.data !== null) {
        setIdPermisoRolUsuarioWeb(permiso.data.id);

        const subGrupo = JSON.parse(permiso.data.subGrupo);
        if (subGrupo) {
          setSubGrupoSelected(subGrupo);
        }
        const grupo = JSON.parse(permiso.data.grupo);
        // console.log('grupo', grupo);
        if (grupo) {
          setGrupoSelected(grupo);
          const idGrupo = grupo.value;
          const listaSubGrupos = await obtenerListaSubGrupos({ idGrupo: idGrupo });
          // console.log('listaSubGrupos', listaSubGrupos);
          if (listaSubGrupos.error === false && Array.isArray(listaSubGrupos.data) && listaSubGrupos.data.length > 0) {
            setListaSubGrupos(listaSubGrupos.data);
          }
        }

        const vehiculos = JSON.parse(permiso.data.vehiculos);
        if (vehiculos) {
          setVehiculoSelected(vehiculos);
        }

        const permisos = JSON.parse(permiso.data.permisos);
        if (permisos) {
          permisosMerged = mergePermisosPages(listaPagesTemplate, permisos);
        }
      }

      setPermisosPages(permisosMerged);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    } finally {
      initialLoadDoneRef.current = true;
      setCargandoPage(false);
    }
  };

  useEffect(() => {
    if (grupoSelected !== null) {
      obtenerListaSubGrupo(grupoSelected);
    }
    if (grupoSelected === null) {
      setListaSubGrupos([]);
      setSubGrupoSelected(null);
    }
  }, [grupoSelected]);

  const obtenerListaSubGrupo = async (grupos) => {
    try {
      setProcessingVisible(true);
      const responseSubGrupos = await obtenerListaSubGrupos({ idGrupo: grupoSelected?.value });
      // console.log('responseSubGrupos', responseSubGrupos);
      if (responseSubGrupos.error === false && Array.isArray(responseSubGrupos.data) && responseSubGrupos.data.length > 0) {
        setListaSubGrupos(responseSubGrupos.data);
      }

    } catch (err) {
      console.log("obtenerListaSubGrupo err");
      console.log(err);
    } finally {
      // if (fetchId === subGrupoFetchIdRef.current) {
      setProcessingVisible(false);
      // }
    }
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    // Auto-hide
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  const handlePageCheckChange = (menuIndex, checked) => {
    setPermisosPages((prev) => {
      const next = sharedCloneObject(prev);
      const page = next[menuIndex];
      page.checked = checked;
      if (Array.isArray(page.acciones)) {
        page.acciones = page.acciones.map((accion) => ({
          ...accion,
          checked,
        }));
      }
      return next;
    });
  };

  const syncMenuCheckedFromSubPages = (menu) => {
    if (!Array.isArray(menu.subMenu) || menu.subMenu.length === 0) {
      return;
    }
    menu.checked = menu.subMenu.every((subPage) => subPage.checked);
  };

  const handleMenuCheckChange = (menuIndex, checked) => {
    setPermisosPages((prev) => {
      const next = sharedCloneObject(prev);
      const menu = next[menuIndex];
      menu.checked = checked;
      if (Array.isArray(menu.subMenu)) {
        menu.subMenu = menu.subMenu.map((subPage) => ({
          ...subPage,
          checked,
          acciones: Array.isArray(subPage.acciones)
            ? subPage.acciones.map((accion) => ({
              ...accion,
              checked,
            }))
            : subPage.acciones,
        }));
      }
      return next;
    });
  };

  const handleSubPageCheckChange = (menuIndex, subIndex, checked) => {
    setPermisosPages((prev) => {
      const next = sharedCloneObject(prev);
      const menu = next[menuIndex];
      const subPage = menu.subMenu[subIndex];
      subPage.checked = checked;
      if (Array.isArray(subPage.acciones)) {
        subPage.acciones = subPage.acciones.map((accion) => ({
          ...accion,
          checked,
        }));
      }
      syncMenuCheckedFromSubPages(menu);
      return next;
    });
  };

  const handleAccionCheckChangeByValue = (menuIndex, accionValue, checked, subIndex = null) => {
    setPermisosPages((prev) => {
      const next = sharedCloneObject(prev);
      const target =
        subIndex === null
          ? next[menuIndex]
          : next[menuIndex].subMenu[subIndex];
      const accionIndex = target.acciones?.findIndex((a) => a.value === accionValue) ?? -1;
      if (accionIndex >= 0) {
        target.acciones[accionIndex].checked = checked;
        if (checked) {
          target.checked = true;
        }
      }
      if (subIndex !== null) {
        syncMenuCheckedFromSubPages(next[menuIndex]);
      }
      return next;
    });
  };

  const handleColumnAccionCheckChange = (menuIndex, accionValue, checked) => {
    setPermisosPages((prev) => {
      const next = sharedCloneObject(prev);
      const menu = next[menuIndex];
      const applyToPage = (page) => {
        const accionIndex = page.acciones?.findIndex((a) => a.value === accionValue) ?? -1;
        if (accionIndex >= 0) {
          page.acciones[accionIndex].checked = checked;
          if (checked) {
            page.checked = true;
          }
        }
      };
      if (menu.subMenu === null) {
        applyToPage(menu);
      } else if (Array.isArray(menu.subMenu)) {
        menu.subMenu.forEach(applyToPage);
        syncMenuCheckedFromSubPages(menu);
      }
      return next;
    });
  };

  const toggleMenuExpanded = (menuIndex) => {
    setExpandedMenus((prev) => {
      const next = new Set(prev);
      if (next.has(menuIndex)) {
        next.delete(menuIndex);
      } else {
        next.add(menuIndex);
      }
      return next;
    });
  };

  const isColumnAllChecked = (menu, accionValue) => {
    const pages = getPagesInSection(menu).filter((page) =>
      page.acciones?.some((a) => a.value === accionValue)
    );
    if (pages.length === 0) return false;
    return pages.every(
      (page) => page.acciones.find((a) => a.value === accionValue)?.checked === true
    );
  };

  const getPageAccionChecked = (page, accionValue) =>
    page.acciones?.find((a) => a.value === accionValue)?.checked === true;

  const renderPermisosTable = (menu, menuIndex) => {
    const pages = getPagesInSection(menu);
    const accionesCols = getSectionAcciones(menu);
    const hasSubMenu = Array.isArray(menu.subMenu) && menu.subMenu.length > 0;

    if (pages.length === 0) return null;

    return (
      <div className="overflow-x-auto">
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr className="border-b border-gray-100 text-gray-500">
              <th className="text-left py-2 px-4 font-medium w-[40%] min-w-[200px]">
                {t("label_funcionalidad")}
              </th>
              {accionesCols.map((col) => (
                <th
                  key={col.value}
                  className="text-center py-2 px-2 font-medium min-w-[90px]"
                >
                  <div className="flex flex-col items-center gap-1">
                    <span className="text-xs leading-tight">{col.label}</span>
                    <input
                      type="checkbox"
                      checked={isColumnAllChecked(menu, col.value)}
                      onChange={(e) =>
                        handleColumnAccionCheckChange(menuIndex, col.value, e.target.checked)
                      }
                      className={CHECKBOX_CLASS}
                    />
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {pages.map((page, rowIndex) => {
              const subIndex = hasSubMenu ? rowIndex : null;
              const rowKey = page.value ?? `${menuIndex}-${rowIndex}`;
              return (
                <tr
                  key={rowKey}
                  className="border-b border-gray-50 hover:bg-gray-50/80"
                >
                  <td className="py-2.5 px-4">
                    <label className="inline-flex items-center gap-2 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={page.checked}
                        onChange={(e) =>
                          hasSubMenu
                            ? handleSubPageCheckChange(menuIndex, rowIndex, e.target.checked)
                            : handlePageCheckChange(menuIndex, e.target.checked)
                        }
                        className={CHECKBOX_CLASS}
                      />
                      <span className="font-medium text-gray-900">{page.label}</span>
                    </label>
                  </td>
                  {accionesCols.map((col) => {
                    const hasAccion = page.acciones?.some((a) => a.value === col.value);
                    if (!hasAccion) {
                      return (
                        <td key={col.value} className="text-center text-gray-300 py-2.5">
                          —
                        </td>
                      );
                    }
                    return (
                      <td key={col.value} className="text-center py-2.5">
                        <input
                          type="checkbox"
                          checked={getPageAccionChecked(page, col.value)}
                          onChange={(e) =>
                            handleAccionCheckChangeByValue(
                              menuIndex,
                              col.value,
                              e.target.checked,
                              subIndex
                            )
                          }
                          className={CHECKBOX_CLASS}
                        />
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  const renderPermisosSection = (menu, menuIndex) => {
    const hasSubMenu = Array.isArray(menu.subMenu) && menu.subMenu.length > 0;
    const pages = getPagesInSection(menu);
    const isExpanded = hasSubMenu ? expandedMenus.has(menuIndex) : true;

    return (
      <div
        key={menu.id ?? menu.label ?? menuIndex}
        className="border border-gray-200 rounded-lg overflow-hidden bg-white"
      >
        <div
          className={`flex items-center justify-between px-4 py-3 bg-gray-50 border-b border-gray-200 ${hasSubMenu ? "cursor-pointer" : ""}`}
          onClick={hasSubMenu ? () => toggleMenuExpanded(menuIndex) : undefined}
        >
          <div className="flex items-center gap-2 min-w-0">
            {hasSubMenu && (
              isExpanded
                ? <ChevronDown className="h-4 w-4 text-gray-500 shrink-0" />
                : <ChevronRight className="h-4 w-4 text-gray-500 shrink-0" />
            )}
            <span className="font-semibold text-gray-900">{menu.label}</span>
            {hasSubMenu && (
              <span className="text-gray-400 text-sm">({pages.length})</span>
            )}
          </div>
          <label
            className="flex items-center gap-2 text-sm text-gray-600 shrink-0 cursor-pointer"
            onClick={(e) => e.stopPropagation()}
          >
            <span>{t("label_seleccionar_todo")}</span>
            <input
              type="checkbox"
              checked={menu.checked}
              onChange={(e) =>
                hasSubMenu
                  ? handleMenuCheckChange(menuIndex, e.target.checked)
                  : handlePageCheckChange(menuIndex, e.target.checked)
              }
              className={CHECKBOX_CLASS}
            />
          </label>
        </div>
        {isExpanded && renderPermisosTable(menu, menuIndex)}
      </div>
    );
  };

  const renderPermisosPages = () => {
    try {
      if (!Array.isArray(permisosPages) || permisosPages.length === 0) {
        return (
          <p className="text-sm text-gray-500">{t("label_sin_datos")}</p>
        );
      }
      return (
        <div className="space-y-3">
          {permisosPages.map((menu, menuIndex) => renderPermisosSection(menu, menuIndex))}
        </div>
      );
    } catch (error) {
      console.log("renderPermisosPages error");
      console.log(error);
      return null;
    }
  };

  const handleSaveClick = async () => {
    try {
      // console.log('handleSaveClick');
      // console.log('grupoSelected');
      // console.log(grupoSelected);
      // console.log('subGrupoSelected');
      // console.log(subGrupoSelected);
      // console.log('vehiculoSelected');
      // console.log(vehiculoSelected);
      // console.log('permisosPages');
      // console.log(permisosPages);
      let objEnviar = {};
      objEnviar.id = idPermisoRolUsuarioWeb;
      objEnviar.idRolUsuarioWeb = formData.id;
      objEnviar.grupo = grupoSelected !== null ? grupoSelected : null;
      objEnviar.subGrupo = subGrupoSelected !== null ? subGrupoSelected : null;
      objEnviar.vehiculos = vehiculoSelected !== null ? vehiculoSelected : null;
      objEnviar.permisos = permisosPages;
      // console.log('objEnviar');
      // console.log(objEnviar);
      // return;
      setProcessingVisible(true);
      if (idPermisoRolUsuarioWeb === null) {
        // console.log('crear correo');
        const response = await crearPermisoRolUsuarioWeb(objEnviar);
        setProcessingVisible(false);
        // console.log('creado');
        // console.log(creado);
        if (response.error === false) {
          showToast(t("alert_se_creo_correctamente"));
          handleCancelClick();
        }
        if (response.error === true) {
          showToast(t("alert_no_se_pudo_crear"));
        }
      }
      if (idPermisoRolUsuarioWeb !== null) {
        // console.log('actualizar correo');
        const response = await actualizarPermisoRolUsuarioWeb(objEnviar);
        setProcessingVisible(false);
        // console.log('modificado');
        // console.log(modificado);
        if (response.error === false) {
          showToast(t("alert_se_modifico_correctamente"));
          handleCancelClick();
        }
        if (response.error === true) {
          showToast(t("alert_no_se_pudo_modificar"));
        }
      }
    } catch (error) {
      console.log('handleSaveClick err');
      console.log(error);
      setProcessingVisible(false);
    }
  };

  const render = () => {
    // console.log('render correo');
    try {
      if (cargandoPage === true) {
        return CargandoCard();
      }
      // if (cargandoPage === false && formData === null) {
      //   return (
      //     <div>
      //       <label> Sin data</label>
      //     </div>
      //   );
      // }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6 bg-gray-100">
          <br />
          <div className="bg-white py-6 shadow-md rounded-lg sm:px-2">
            <div className="flex items-center justify-between mb-4">
              <div>
                <div className="flex items-center gap-2">
                  <ArrowBack onClick={handleCancelClick} />
                  <h2 className="text-xl font-bold text-gray-900">{t("label_gestionar_permisos")}</h2>
                </div>
              </div>
            </div>
            {formData !== null && (
              <div className="mb-4 text-sm text-gray-600">
                <span className="font-semibold text-gray-800">{formData.codigo}</span>
                {formData.descripcion ? ` — ${formData.descripcion}` : ""}
              </div>
            )}
            <hr className="my-4" />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label className="block text-[#0F3457] font-semibold" htmlFor="grupo">
                  {t("label_grupo")}
                </label>
                <Select
                  options={listaGrupos}
                  isSearchable={true}
                  isClearable={true}
                  isMulti={false}
                  value={grupoSelected}
                  onChange={(event) => setGrupoSelected(event)}
                  placeholder={t("placeholder_seleccione_grupo")}
                />
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label className="block text-[#0F3457] font-semibold" htmlFor="sub_grupo">
                  {t("label_sub_grupo")}
                </label>
                <Select
                  options={listaSubGrupos}
                  isSearchable={true}
                  isClearable={true}
                  isMulti={false}
                  value={subGrupoSelected}
                  onChange={(event) =>
                    setSubGrupoSelected(
                      Array.isArray(event) ? sharedDedupeSelectOptions(event) : event
                    )
                  }
                  placeholder={t("placeholder_seleccione_sub_grupo")}
                />
              </div>
              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                <label className="block text-[#0F3457] font-semibold" htmlFor="listaVehiculos">
                  {t("label_lista_vehiculos")}
                </label>
                <Select
                  options={listaVehiculos}
                  isSearchable={true}
                  isClearable={true}
                  value={vehiculoSelected}
                  onChange={(event) => setVehiculoSelected(event)}
                  placeholder={t("placeholder_seleccione_vehiculo")}
                  isMulti={true}
                  classNamePrefix="react-select"
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 999 }),
                    menu: (base) => ({ ...base, zIndex: 999 }),
                  }}
                />
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                {renderPermisosPages()}
              </div>
            </div>
            <br />
            <div className="grid grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                <div className="flex justify-between">
                  <button
                    type="button"
                    className={ESTILO_BOTON_GENERAL_CANCELAR}
                    onClick={handleCancelClick}
                  >
                    Cancelar
                  </button>
                  {sendRequest === false &&
                    <button
                      type="button"
                      className={ESTILO_BOTON_GENERAL_ACEPTAR}
                      onClick={handleSaveClick}
                    >
                      Aceptar
                    </button>
                  }
                  {sendRequest === true &&
                    <BtnRequestComponent label={t("label_aceptar")} />
                  }
                </div>
              </div>
            </div>
          </div>
          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
        </div>
      );
    } catch (err) {
      console.log('formData render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
